import { render, staticRenderFns } from "./AgentCorpMail.vue?vue&type=template&id=fa72d9a4&"
import script from "./AgentCorpMail.vue?vue&type=script&lang=js&"
export * from "./AgentCorpMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports